// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// إعدادات Firebase الخاصة بمشروعك
const firebaseConfig = {
  apiKey: "AIzaSyDgLndBF-7XFEDjdzGoz62MkIXokA7wMxs",
  authDomain: "jobcardsystem-580a3.firebaseapp.com",
  projectId: "jobcardsystem-580a3",
  storageBucket: "jobcardsystem-580a3.firebasestorage.app",
  messagingSenderId: "731291727604",
  appId: "1:731291727604:web:a46522d6d42f2d918850a1"
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// التهيئة العامة
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // ✅ تمرير app هنا

// التصدير
export { auth, db, storage };
